import { cn } from "~/lib/utils";

type SkeletonProps = React.HTMLAttributes<HTMLDivElement>;

/**
 * Shimmering placeholder block. Compose several to mimic the shape of the content
 * that's loading (a text line, a row, an avatar). The `shimmer` utility (globals)
 * sweeps a low-contrast highlight and falls back to a flat fill under reduced-motion.
 */
export function Skeleton({ className, ...props }: SkeletonProps) {
  return <div className={cn("shimmer rounded-[var(--radius-xs)]", className)} aria-hidden {...props} />;
}
